import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Button, Form } from 'react-bootstrap'
import axios from 'axios'

import { handleErrorAndGenerateMessage } from '../../../functions/errorHandling'
import { getServerUrl } from '../../../functions/getServerUrl'


const ChartReviewNoteForm = (props) => {
  // REDUX
  const dispatch = useDispatch()
  const patientChartUrl = useSelector(state => state.chartFormReducer.patientChartUrl)
  const currentUser = useSelector(state => state.loginReducer.currentUser)

	const [noteText, changeNoteText] = useState('')
  const [errorMessage, setErrorMessage] = useState('')

  const setNoteText = () => {
    if (props.method === 'PATCH') {
      changeNoteText(props.text || '')
    }
  }

  useEffect(setNoteText, [])

	const postReviewNote = () => {
    if (props.readOnly || !noteText) {
      return null
    }
    
		const note = {
			text: noteText,
			section: props.section,
		}

    let url
    if (props.method === 'PATCH' && props.noteUrl) {
      url = props.noteUrl
    } else if (props.section === 'ADR') {
			url = `${getServerUrl()}/adverse-event-review-notes/`
		} else {
			url = `${getServerUrl()}/chart-review-notes/`
    }
		
		if (props.section === 'ADR') {
			note.cefiderocol_adverse_event = props.adverseEventUrl
		} else {
			note.patient_chart = patientChartUrl
		}

		axios({
			method: props.method,
			url,
			headers: { "Authorization": "JWT " + localStorage.getItem("jwt") },
			data: note,
		})
		.then(response => {
			if (props.method === 'POST') {
				changeNoteText('')
			}
			props.handleSaveComplete({ 
				...response.data, 
				created_by: currentUser, 
				adverseEventName: props.adverseEventName,
			})
		})
		.catch(error => {
      const message = handleErrorAndGenerateMessage(error, 'saving your note', dispatch)
      setErrorMessage(message)
		})
	}

  if (props.readOnly) {
    return null
  } else {
    return (
      <div style={{textAlign: 'right'}}>
        <Form.Control
          as='textarea'
          rows={4}
          value={noteText}
          onChange={(e) => changeNoteText(e.target.value)}
          placeholder={props.formPlaceholder || `Enter ${props.section.toLowerCase()} notes`}
          required={true}
        />
  
        <br />

        {errorMessage ?
          <p style={{color: 'red'}}>
            {errorMessage}
          </p>
          :
          null
        }
  
        <Button onClick={postReviewNote}>
          {props.saveButtonText || "Save Note"}
        </Button>
  
      </div>
    )
  }

}

export default ChartReviewNoteForm
